import { FC, useEffect } from 'react';
import { motion } from 'framer-motion';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import TransformationsPage from './pages/TransformationsPage';
import GalleryPage from './pages/GalleryPage';
import AdminPage from './pages/AdminPage';
import AdminPanel from './components/AdminPanel';
import './App.css';

const ScrollToTop: FC = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

// Add structured data for the organization (JSON-LD)
const StructuredData: FC = () => {
  const companyData = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": "Aluxim",
    "image": "https://www.aluxim.pl/logo.png",
    "description": "Profesjonalne ogrody zimowe, zabudowy tarasów i balkonów. Nowoczesne rozwiązania dla Twojego domu od firmy Aluxim z wieloletnim doświadczeniem.",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "ul. Budowlana 123",
      "addressLocality": "Warszawa",
      "postalCode": "00-000",
      "addressCountry": "PL"
    },
    "telephone": "+48 123 456 789",
    "email": "kontakt@aluxim.pl",
    "sameAs": [
      "https://www.facebook.com/aluxim",
      "https://www.instagram.com/aluxim"
    ],
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "08:00",
      "closes": "16:00"
    },
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 52.2297,
        "longitude": 21.0122
      },
      "geoRadius": 50000
    },
    "serviceType": [
      "Ogrody zimowe",
      "Zabudowa tarasów",
      "Zabudowa balkonów",
      "System bezramowy",
      "Zadaszenia tarasów",
      "Daszki"
    ]
  };

  useEffect(() => {
    // Inject JSON-LD structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(companyData);
    document.head.appendChild(script);
    
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  
  return null;
};

const AppContent: FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Only set up anchor link scrolling on the home page
    if (location.pathname === '/') {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          
          const href = anchor.getAttribute('href');
          if (!href) return;
          
          const target = document.querySelector(href);
          if (!target) return;
          
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - 100,
            behavior: 'smooth'
          });
        });
      });
    }
  }, [location.pathname]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <StructuredData />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/transformacje" element={<TransformationsPage />} />
        <Route path="/galeria" element={<GalleryPage />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin-old" element={<AdminPage />} />
      </Routes>
    </motion.div>
  );
};

const App: FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
};

export default App;
